import React, { useEffect } from "react";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { EyeIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import TableHeader from "../Utility/TableHeader";
import { Pagination } from "../../helper/HelperTwo";
import axios from "axios";
import { toast } from "react-toastify";

function QuotationList({
  setEditIdCryptForQuotation,
  setOpenDialogBoxForQuotation,
  quotationDatas,
  setIsEditing,
  setQuotationInputs,
  setLoading,
  setQuotationProducts,
  fetchQuotationsData,
  setCurrentPage,
  paginationQuotationData,
  id_crypt,
  showForm,
  setCgst,
  setSgst,
  filterParams,
  setSaveBtn,
  setSaveBtnOpen
}) {
  const headers = [
    "S NO",
    "Quotation No",
    "Quotation Date",
    "Lead",
    "Employee",
    "Status",
    "Total Amount",
    "Action",
  ];

  console.log(paginationQuotationData,"list");
  

  const userForView = JSON.parse(localStorage.getItem("user"));
  const quotationPermissionForView =
    userForView?.quotation_role_based_access?.some(
      (access) => access.label_id == 6 && access.label_value != 0
    );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  const quotationPermissionForDelete =
    userForDelete?.quotation_role_based_access?.some(
      (access) => access.label_id == 4 && access.label_value != 0
    );

  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom
 

  const filteredQuotations =
    currentLoginIdForAdmin === 1
      ? paginationQuotationData?.data || []
      : paginationQuotationData?.data?.filter(
          (emp) =>
            Number(emp.employee?.id) === Number(currentLoginIdForEmployee)
        );

        console.log(filteredQuotations,"filteredQuotations");
        


  const handleViewForQuotation = async (id_crypt) => {
    setIsEditing(true);
    setEditIdCryptForQuotation(id_crypt);
    setSaveBtn("update")
    setSaveBtnOpen(false)
    setOpenDialogBoxForQuotation(true);
    try {
      const response = await axios.get(
        `public/api/admin/quotation/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      setQuotationInputs({
        quotation_number: response?.data.quotation.quotation_number,
        quotation_date: response?.data.quotation.quotation_date,
        quotation_validity_date:
          response?.data.quotation.quotation_validity_date,
        quotation_status: response?.data.quotation.quotation_status,
        employee_id: Number(response?.data.quotation.employee?.id),
        lead_id: response?.data.quotation.lead?.id,
        terms_and_conditions: response?.data.quotation.terms_and_conditions,
        cost: response?.data.quotation.cost,
        tax: response?.data.quotation.tax,
        sub_total: response?.data.quotation.sub_total,
        total_amount: response?.data.quotation.total_amount,
        branch_id: response?.data.quotation.branch_id,
      });
      setCgst(response?.data.quotation.cgst);
      setSgst(response?.data.quotation.sgst);

      setQuotationProducts(
        response?.data?.quotation.quotation_product.map((product) => ({
          product_id: product.product_id,
          product_name: product.product_name,
          quantity: product.quantity,
          price: product.price,
          gst: product.gst,
          gst_amount: product.gst_amount,
          total_price: product.total_price,
        }))
      );
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForQuotation(id_crypt);
    }
  }, [showForm, id_crypt]);

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);

      setCurrentPage(newPage);
      fetchQuotationsData(newPage, filterParams);
    }
  };

  return (
    <>
      <div className="grid md:grid-cols-1 gap-4">
        <div className="overflow-x-auto">
          <table className="min-w-full max-w-full divide-y divide-gray-300 mt-8">
            <TableHeader headers={headers} />
            <tbody className="divide-y divide-gray-200 bg-white">
              {/* {paginationquotationData?.data?.map((quotation, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="py-4 px-4 text-center text-sm text-gray-700 whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="py-4 px-4 text-center text-sm text-gray-700 whitespace-nowrap">
                    {quotation.first_name}
                  </td>
                  <td className="py-4 px-4 text-center text-sm text-gray-700 whitespace-nowrap">
                    {quotation.company_name}
                  </td>
                  <td className="py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {quotation.quotation_email}
                  </td>
                  <td className="py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {quotation.quotation_phone}
                  </td>
               

                  <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                  <QuotationView id_crypt={quotation.id_crypt}/>
                    <span
                      className="my-anchor-edit relative group cursor-pointer bg-green-400 rounded-md p-1"

                      // onClick={() => handleEditForQuotation(quotation.id_crypt)}
                    >
                      <PencilSquareIcon className="h-5 w-5 text-white" />
                      <Tooltip
                        anchorSelect=".my-anchor-edit"
                        place="top"
                        className="text-xs p-0"
                        style={{ fontSize: "12px", padding: "0.3rem" }}
                      >
                        Edit
                      </Tooltip>
                    </span>
                    <DeleteConfirmation
                      id_crypt={quotation.id_crypt}
                      apiType="quotation"
                      // fetchClientData={fetchquotationsData}
                    />
                  </td>
                </tr>
              ))} */}
              {filteredQuotations && filteredQuotations.length > 0 ? (
                filteredQuotations?.map((quotation, index) => (
                  // {paginationQuotationData?.data?.length > 0 ? (
                  // paginationQuotationData?.data?.map((quotation, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition duration-300 ease-in-out"
                  >
                    <td className="py-4 px-4 text-center  text-md whitespace-nowrap">
                      {paginationQuotationData.from + index}
                    </td>
                    <td className="py-4 px-4 text-center text-gray-500 text-md whitespace-nowrap">
                      {quotation?.quotation_number}
                    </td>
                    <td className="py-4 px-4 text-center text-gray-500 text-md whitespace-nowrap">
                      {quotation?.quotation_date}
                    </td>
                    <td className="py-4 px-4 text-center text-gray-500 text-md whitespace-nowrap">
                      {quotation?.lead?.name}
                    </td>
                    <td className="py-4 px-4 text-center text-gray-500 text-md whitespace-nowrap">
                      {quotation?.employee?.name}
                    </td>
                    <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center">
          <span
            className={`border rounded px-2 py-1 ${
              quotation.quotation_status?.name === "Pending"
                ? "border-blue-600 text-blue-600"
                : quotation.quotation_status?.name === "Approved"
                ? "border-green-600 text-green-600"
                : quotation.quotation_status?.name === "Rejected"
                ? "border-red-500 text-red-500"
                : quotation.quotation_status?.name === "In Progress"
                ? "border-purple-600 text-purple-600"
                : "border-gray-400 text-gray-600"
            }`}
          >
            {quotation.quotation_status?.name}
          </span>
        </td>
                    <td className="py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                      {quotation?.total_amount}
                    </td>

                    <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                      {/* <QuotationView id_crypt={quotation.id_crypt}/> */}
                      {quotationPermissionForView && (
                        <span
                          className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                          onClick={() =>
                            handleViewForQuotation(quotation?.id_crypt)
                          }
                        >
                          <EyeIcon className="h-5 w-5 text-white" />
                          <Tooltip
                            anchorSelect=".my-anchor-view"
                            place="top"
                            className="text-xs p-0"
                            style={{ fontSize: "12px", padding: "0.3rem" }}
                          >
                            View
                          </Tooltip>
                        </span>
                      )}

                      {quotationPermissionForDelete && (
                        <DeleteConfirmation
                          id_crypt={quotation.id_crypt}
                          apiType="quotation"
                          fetchClientData={fetchQuotationsData}
                          setLoading={setIsEditing}
                        />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    className="text-center py-4 px-4 text-sm text-gray-500 whitespace-nowrap"
                  >
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* {paginationquotationData && (
          <Pagination
            links={paginationquotationData.links}
            currentPage={paginationquotationData.current_page}
            totalResults={paginationquotationData.total}
            from={paginationquotationData.from}
            to={paginationquotationData.to}
            lastPage={paginationquotationData.last_page}
            onPageChange={handlePageChange}
          />
        )} */}
{filteredQuotations?.length > 0 ? (
  <Pagination
    links={paginationQuotationData.links} // Keep original links for navigation
    currentPage={paginationQuotationData.current_page}
    totalResults={filteredQuotations.length} // Update total results based on filtered data
    from={filteredQuotations.length > 0 ? 1 : 0} // Start from 1 if there are results
    to={filteredQuotations.length} // Show the total count as the last item
    lastPage={Math.ceil(filteredQuotations.length / (paginationQuotationData.per_page || 10))} // Calculate last page dynamically
    onPageChange={handlePageChange}
  />
) : (
  paginationQuotationData && (
    <Pagination
      links={paginationQuotationData.links}
      currentPage={paginationQuotationData.current_page}
      totalResults={paginationQuotationData.total}
      from={paginationQuotationData.from}
      to={paginationQuotationData.to}
      lastPage={paginationQuotationData.last_page}
      onPageChange={handlePageChange}
    />
  )
)}


       
      </div>
    </>
  );
}

export default QuotationList;
